import { isDefined } from "@clipboard-health/util-ts";

import { useIsRebrand } from "../theme/RebrandProvider";

interface LogoProps {
  url?: string;
  float?: "left" | "right" | "none" | "inline-start" | "inline-end";
  display?: string;
  height?: string | number;
  width?: string | number;
  margin?: string;
}

function getBasePath(): string {
  if (isDefined(process.env.REACT_APP_BASE_PATH) && process.env.REACT_APP_BASE_PATH !== "") {
    return process.env.REACT_APP_BASE_PATH;
  }

  return "/";
}

export function ClipboardLogo(props: LogoProps) {
  const { url, float, display, height, width, margin } = props;
  const isRebrand = useIsRebrand();
  const basePath = getBasePath();

  const defaultUrl = isRebrand
    ? `${basePath}assets/clipboard-wordmark-brown.png`
    : `${basePath}clipboard1_w.png`;
  const urlString = url ?? defaultUrl;

  return (
    <div
      className="logo"
      style={{
        float,
        display: display ?? "inline-block",
        height,
        width,
        background: `url("${urlString}") center center / contain no-repeat`,
        margin: margin ?? "0 0 0 0",
      }}
    />
  );
}

export function BunnyLogo(props: LogoProps) {
  const { url, float, display, height, width, margin } = props;
  const isRebrand = useIsRebrand();
  const basePath = getBasePath();

  const defaultUrl = isRebrand
    ? `${basePath}assets/clipboard-symbol-yellow.png`
    : `${basePath}bunnyVerticalAgnostic.png`;
  const urlString = url ?? defaultUrl;

  return (
    <div
      className="logo"
      style={{
        float,
        display,
        height,
        width,
        background: `url("${urlString}") center center / contain no-repeat`,
        margin: margin ?? "0 0 0 0",
      }}
    />
  );
}
